export const getTooltipText = (t, tooltipKey) => {
  const tooltips = {
    day: t('Días'),
    week: t('Semanas'),
    month: t('Meses'),
    quarter: t('Trimestres'),
  }
  return tooltips[tooltipKey]
}
